// @flow
import { filter } from 'ramda';

import type { Params } from 'app/common/components/Cafeteria/dataTypes/order/ComplexFree.types';

import type { Request } from '../../../../index';


const dateFormatApi = 'YYYY-MM-DD';

type ApiParams = {
  complex_guid: string,
  customer_id: number | string,
  date: string,
  order_id?: number | string,
  group_type: 'Klass',
  purchase_guid?: string,
}

export const convertParams = ({
  id,
  date,
  customerId,
  orderRequestId,
  groupType,
  purchaseId,
}: Params): [ApiParams, null] => {
  return [filter(Boolean, {
    complex_guid: id,
    customer_id: customerId,
    order_id: orderRequestId,
    date: date.getString(dateFormatApi),
    group_type: groupType || 'Klass',
    purchase_guid: purchaseId,
  }), null];
};

type ResultApi = boolean

export const convertResult = (dataApi: ResultApi): boolean | null => {
  if (typeof dataApi === 'boolean') {
    return dataApi;
  }
  return null;
};

export const GET_CAFETERIA_CUSTOMER_COMPLEXES_FREE: Request<
  Params,
  boolean | null,
  void
> = [
  'cafeteria/customer/orders/complexes/free',
  'get',
  ['data', 'free'],
];
